import React from "react";
import Modal from "@mui/material/Modal";

export const ExpandableImage = ({src, alt, className, smallSize}) => {
    const [expand, setExpand] = React.useState(false);

    if (!expand) {
        return <img
            src={src}
            alt={alt}
            className={className ? className + " expandable-image" : "expandable-image"}
            onClick={() => setExpand(true)}
            style={{cursor: "zoom-in", maxHeight: "260px"}} />;
    }

    return <Modal
        open={expand}
        onClose={() => setExpand(false)}
        className={"expanded-image-modal"}>
        <img
            src={src}
            alt={alt}
            className={"expanded-image"}
            onClick={() => setExpand(false)}
            style={{cursor: "zoom-out", maxWidth: "90vw"}} />
    </Modal>
}


export default ExpandableImage;